import { PropType, computed, defineComponent, onMounted, ref } from 'vue'

import { TrackingParameter, track } from '@sunrise/tracking'

import { DecoratedPartnerDetail } from '../../ts/mapper/decoratedEstateDetailMapper.interface'
import { buildPartnerExposeErrorData } from '../../ts/shared/trackingDataBuilder'
import { appendCSSFiles, appendJSFiles } from '../../ts/utils/assetsUtils'

import { PartnerCSSResource, PartnerJSResource } from './MsDetailPartnerWebComponent.enum'

export default defineComponent({
    name: 'MsDetailPartnerWebComponent',
    props: {
        estate: {
            type: Object as PropType<DecoratedPartnerDetail>,
            required: true,
        },
    },
    setup(props) {
        const webComponentRef = ref<typeof HTMLElement | null>(null)
        const normalizedId = computed(() => props.estate.exposeeId.replace('iw-', ''))

        function initWebComponent(exposeEl: HTMLElement): void {
            Promise.all([
                appendCSSFiles(Object.values(PartnerCSSResource)),
                appendJSFiles(Object.values(PartnerJSResource)),
            ])
                .then(() => {
                    addEventListener(exposeEl)
                })
                .catch((error) => {
                    console.warn('Error appending and initializing resources:', error)
                })
        }

        function addEventListener(exposeEl: HTMLElement): void {
            exposeEl.addEventListener('error', () => {
                const tealiumData: TrackingParameter = buildPartnerExposeErrorData(props.estate.exposeeId)
                track(tealiumData)
            })
        }

        onMounted(() => {
            const exposeEl: HTMLElement | null = webComponentRef.value as HTMLElement | null

            if (exposeEl) {
                initWebComponent(exposeEl)
            }
        })

        return {
            normalizedId,
            webComponentRef,
        }
    },
})
